import {useCallback} from 'react'

import {useSuiContext} from '@s-ui/react-context'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'
import {criteoTrackEvents, useCriteoTrack} from '@adv-mt/mt-tracking-use-criteo'

/**
 * The two tracking callbacks the related-ads modal expects, ported from legacy
 * (DetailFormContactSellerModalWrapper.js:101-129). The modal itself emits no
 * analytics: it hands the contacted ad and the ad list up, exactly like the v2
 * contact card does, so the payloads stay owned by the page.
 *
 * `leadData` is spread as legacy spreads it — last for the lead event, and not
 * at all for the impression one.
 */
const useRelatedAdsModalTracking = ({adDetail, contactType} = {}) => {
  const {domain} = useSuiContext()
  const {track} = useAnalyticsTrack()
  const {track: criteoTrack} = useCriteoTrack()

  const onContactRelatedAd = useCallback(
    ({id, messageContactId, leadData}) => {
      track({
        event: 'Lead Triggered',
        data: {lead_type: 'Recommended Ad Replied Email', hit_information3: messageContactId, ...leadData}
      })
      criteoTrack({event: criteoTrackEvents.TRACK_TRANSACTION, eventData: {adId: id}})
    },
    [track, criteoTrack]
  )

  const onToggleRelatedAdsModal = useCallback(
    ({isOpen, relatedAds}) => {
      if (!isOpen || !relatedAds) return

      domain
        .get('get_page_tracking_data_use_case')
        .execute({page: 'ads-detail', pageType: 'similar-ads', similarAds: relatedAds, contactType, adDetail})
        .then(({event, data}) => track({event, data}))
    },
    [adDetail, contactType, domain, track]
  )

  return {onContactRelatedAd, onToggleRelatedAdsModal}
}

export default useRelatedAdsModalTracking
